"use strict";
exports.__esModule = true;
function getDeviceTransactionConfig(_a) {
    var transaction = _a.transaction, estimatedFees = _a.status.estimatedFees;
    var fields = [];
    if (transaction.useAllAmount) {
        fields.push({
            type: "text",
            label: "Method",
            value: "Send all"
        });
    }
    else {
        fields.push({
            type: "text",
            label: "Method",
            value: "Send"
        });
        fields.push({
            type: "amount",
            label: "Amount"
        });
    }
    if (!estimatedFees.isZero()) {
        fields.push({
            type: "fees",
            label: "Fees"
        });
    }
    if (transaction.memo) {
        fields.push({
            type: "text",
            label: "Memo",
            value: transaction.memo
        });
    }
    return fields;
}
exports["default"] = getDeviceTransactionConfig;
//# sourceMappingURL=deviceTransactionConfig.js.map